import { ConnectionNames } from "../Contracts";
import { connectWithToken } from "../Common/Helpers";
import { SDQuerySubscribersStore } from "../C_Sportsbook/Helpers";
import { OBQuerySubscribersStore } from "../C_OpenBets";
export const ConnectWithToken = {
    [ConnectionNames.sports]: connectWithToken.bind(undefined, ConnectionNames.sports, SDQuerySubscribersStore),
    [ConnectionNames.openBets]: connectWithToken.bind(undefined, ConnectionNames.openBets, OBQuerySubscribersStore)
};
//# sourceMappingURL=ConnectWithToken.js.map